import { axiosInstance } from '@configs/axios/axiosInstance';

import type { Profile } from '../../profile.types';

export async function fetchProfile(organizationId: string): Promise<Profile> {
  const { data } = await axiosInstance.get<Profile>('/client-profiles', {
    params: { organizationId },
  });
  return data;
}
